// Ambience themes for the Advent Calendar game (background + particles).
export const ADVENT_THEMES = {
  snow: { bg: ["#0b1026", "#141b3d", "#1a1236"], particle: "flake", motion: "fall", colors: ["#ffffff"] },
  stars: { bg: ["#050b1f", "#0b1a3f", "#0a1030"], particle: "star", motion: "twinkle", colors: ["#fff7cc", "#ffffff", "#bfdbfe"] },
  autumn: { bg: ["#3b0f0f", "#5a1e12", "#2a0e0e"], particle: "leaf", motion: "sway", colors: ["#f97316", "#ea580c", "#d97706", "#b45309"] },
  spring: { bg: ["#14532d", "#166534", "#0f3d2e"], particle: "petal", motion: "sway", colors: ["#f9a8d4", "#f472b6", "#fbcfe8", "#ffffff"] },
  summer: { bg: ["#0c4a6e", "#0e7490", "#f97316"], particle: "bubble", motion: "rise", colors: ["#ffffff"] },
  valentine: { bg: ["#4c0519", "#9f1239", "#be123c"], particle: "heart", motion: "rise", colors: ["#fb7185", "#f43f5e", "#fecdd3"] },
  ramadan: { bg: ["#052e16", "#064e3b", "#0f2a1e"], particle: "crescent", motion: "float", colors: ["#fcd34d", "#fde68a"] },
  birthday: { bg: null, particle: "confetti", motion: "sway", colors: ["#f472b6", "#facc15", "#34d399", "#60a5fa", "#a78bfa"] },
  none: { bg: ["#0b1026", "#141b3d", "#1a1236"], particle: null, motion: null, colors: [] },
};

export const ADVENT_THEME_KEYS = Object.keys(ADVENT_THEMES);

export const ADVENT_INTENSITY_COUNT = { light: 12, normal: 26, festive: 48 };

function hexToRgb(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  return m ? [parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)] : null;
}

function shade(hex, pct) {
  const rgb = hexToRgb(hex);
  if (!rgb) return hex;
  const f = pct < 0 ? 0 : 255;
  const a = Math.abs(pct) / 100;
  return `rgb(${rgb.map((c) => Math.round(c + (f - c) * a)).join(",")})`;
}

function luminance(hex) {
  const rgb = hexToRgb(hex);
  if (!rgb) return 0;
  return (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
}

export function adventTheme(game) {
  return ADVENT_THEMES[game?.advent_theme] ? game.advent_theme : "snow";
}

export function adventParticleCount(game) {
  return ADVENT_INTENSITY_COUNT[game?.advent_particles_intensity] ?? ADVENT_INTENSITY_COUNT.normal;
}

// CSS background for the calendar card: custom colour > theme gradient.
export function adventBackground(game) {
  const key = adventTheme(game);
  const custom = game?.advent_bg_color || (key === "birthday" ? game?.theme_color : null);
  if (custom && hexToRgb(custom)) {
    const grad = `linear-gradient(160deg, ${custom} 0%, ${shade(custom, -30)} 60%, ${shade(custom, -50)} 100%)`;
    return luminance(custom) > 0.55
      ? `linear-gradient(rgba(0,0,0,.38), rgba(0,0,0,.38)), ${grad}`
      : grad;
  }
  const [a, b, c] = ADVENT_THEMES[key].bg || ADVENT_THEMES.snow.bg;
  return `linear-gradient(160deg, ${a} 0%, ${b} 55%, ${c} 100%)`;
}

// Swatch used in the editor tiles (theme gradient, brand colour for birthday).
export function adventSwatch(key, game) {
  return adventBackground({ ...game, advent_theme: key, advent_bg_color: null });
}
